"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardAccessOut = void 0;
class DashboardAccessOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return DashboardAccessOut.attributeTypeMap;
    }
}
exports.DashboardAccessOut = DashboardAccessOut;
DashboardAccessOut.discriminator = undefined;
DashboardAccessOut.attributeTypeMap = [
    {
        "name": "token",
        "baseName": "token",
        "type": "string",
        "format": ""
    },
    {
        "name": "url",
        "baseName": "url",
        "type": "URI",
        "format": "uri"
    }
];
//# sourceMappingURL=DashboardAccessOut.js.map